import React from "react";
import "./ImageGalleryModal.css"; // Optional styling


export default function ImageGalleryModal({ isOpen, onClose, onSelect, images, imagesrc }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h3>Select an Image</h3>
        <div className="gallery">
          {images.map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt={`Gallery ${idx}`}
              className="gallery-img"
              onClick={() => {
                onSelect(src);
                onClose();
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
